import { useState, useEffect, Fragment } from "react";
import Config from "../../Config";
import back from "../../back.png";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputText from "../../helpers/InputText";
import InputDecimal from "../../helpers/InputDecimal";
import InputCombo from "../../helpers/InputCombo";
import MenuNormal from "../../helpers/MenuNormal";
import InputDate from "../../helpers/InputDate";
import InputNIP from "../../helpers/InputNIP";
import InputPostCode from "../../helpers/InputPostCode";
import MenuTable from "../../helpers/MenuTable";
import ClientReview from "../home/ClientReview";
import InputTextArea from "../../helpers/InputTextArea";
import CalculateReview from "./CalculateReview";



function InvoiceForm(props)
{
            
            const [checked1, setChecked1] = useState(false);
            const handleChange1= () => {
                setChecked1(!checked1);
            };  

            const [checked2, setChecked2] = useState(false);
            const handleChange2= () => {
                setChecked2(!checked2);
            };  


            const [checked3, setChecked3] = useState(false);
            const handleChange3= () => {
                setChecked3(!checked3);
            };  


            const [checked4, setChecked4] = useState(false);
            const handleChange4= () => {
                setChecked4(!checked4);
            };  


            const [checked5, setChecked5] = useState(false);
            const handleChange5= () => {
                setChecked5(!checked5);
            };  


            const [errTab, setErrTab] = useState([]); 


            const defPoz = [
                    {  id: -1,  sl_pozycje_id: -1, nazwa: '', cena_j_netto:0.00, cena_j_brutto: 0.00, stawka_vat: 23, ilosc: 0, jm: 'szt.', cena_netto: 0.0, razem_vat:0.0,  cena_brutto: 0.0,  },
                    {  id: -1,  sl_pozycje_id: -1, nazwa: '', cena_j_netto:0.00, cena_j_brutto: 0.00, stawka_vat: 23, ilosc: 0, jm: 'szt.', cena_netto: 0.0, razem_vat:0.0,  cena_brutto: 0.0,  },
                    {  id: -1,  sl_pozycje_id: -1, nazwa: '', cena_j_netto:0.00, cena_j_brutto: 0.00, stawka_vat: 23, ilosc: 0, jm: 'szt.', cena_netto: 0.0, razem_vat:0.0,  cena_brutto: 0.0,  },
                    {  id: -1,  sl_pozycje_id: -1, nazwa: '', cena_j_netto:0.00, cena_j_brutto: 0.00, stawka_vat: 23, ilosc: 0, jm: 'szt.', cena_netto: 0.0, razem_vat:0.0,  cena_brutto: 0.0,  },
                    {  id: -1,  sl_pozycje_id: -1, nazwa: '', cena_j_netto:0.00, cena_j_brutto: 0.00, stawka_vat: 23, ilosc: 0, jm: 'szt.', cena_netto: 0.0, razem_vat:0.0,  cena_brutto: 0.0,  },
                    {  id: -1,  sl_pozycje_id: -1, nazwa: '', cena_j_netto:0.00, cena_j_brutto: 0.00, stawka_vat: 23, ilosc: 0, jm: 'szt.', cena_netto: 0.0, razem_vat:0.0,  cena_brutto: 0.0,  },
                    {  id: -1,  sl_pozycje_id: -1, nazwa: '', cena_j_netto:0.00, cena_j_brutto: 0.00, stawka_vat: 23, ilosc: 0, jm: 'szt.', cena_netto: 0.0, razem_vat:0.0,  cena_brutto: 0.0,  },
                    {  id: -1,  sl_pozycje_id: -1, nazwa: '', cena_j_netto:0.00, cena_j_brutto: 0.00, stawka_vat: 23, ilosc: 0, jm: 'szt.', cena_netto: 0.0, razem_vat:0.0,  cena_brutto: 0.0,  },
                    {  id: -1,  sl_pozycje_id: -1, nazwa: '', cena_j_netto:0.00, cena_j_brutto: 0.00, stawka_vat: 23, ilosc: 0, jm: 'szt.', cena_netto: 0.0, razem_vat:0.0,  cena_brutto: 0.0,  },
                    {  id: -1,  sl_pozycje_id: -1, nazwa: '', cena_j_netto:0.00, cena_j_brutto: 0.00, stawka_vat: 23, ilosc: 0, jm: 'szt.' , cena_netto: 0.0, razem_vat:0.0,  cena_brutto: 0.0,  },       
                ];

            const [row, setRow] = useState({
                id: -1,
                fak_kontrahenci_id: -1,
                numer_dokumentu: '',
                data_wystawienia: '',
                data_sprzedazy: '',
                termin_platnosci: '',

                zatwierdzona: -1,
                anulowana: -1,

                razem_netto: 0.0,
                razem_vat: 0.0,
                razem_brutto: 0.0,
                do_zaplaty: 0.0,

                sp_nazwa: '',
                sp_ulica: '',
                sp_kod_pocztowy: '',
                sp_miejscowosc: '',
                sp_nip: '',
                sp_regon: '',
                sp_telefon: '',

                kl_nip: '',
                kl_nazwa: '',
                kl_ulica: '',
                kl_kod_pocztowy: '',
                kl_miejscowosc: '',
                kl_nip: '',
                kl_regon: '',
                kl_telefon: '',

                odbr_nip: '',
                odbr_nazwa: '',
                odbr_ulica: '',
                odbr_kod_pocztowy: '',
                odbr_miejscowosc: '',
                odbr_regon: '',

                platnosc_z_gory: '0',
                sposob_platnosci: 'Przelew',

                korekta_powod: '',
                uwagi: '',

                odwrotne_obciazenie: '',

                dodatkowy_opis_1_klucz: '',
                dodatkowy_opis_1_wartosc: '',
                dodatkowy_opis_2_klucz: '',
                dodatkowy_opis_2_wartosc: '',


                poz_max: 1,
                pozycje: defPoz,

            }); 

            var tmpRow = row;

            const [goCalculate, setGoCalculate] = useState(0);       
            const [isChanged, setIsChanged] = useState(0); // jesli 1 to cos zostalo zmienione..



            const [nParam, setNParam] = useState(''); //parametr ogolnego przeznaczenia..

            const paramListener = (filedName, val, correct, msg) => { 
                setNParam(val);
            }


            const [view, setView] = useState ( {view:"list", id: -1}  );

            const onBack = (e) => {
                setView({view:"list", id: -1}  );
            }

            const onSuccess = (e) => {
                setView({view:"list", id: -1}  );
                getCalcDet();
            }

             const changeView = (e ) => {
                    var v = e.target.getAttribute('v');
                    var id = e.target.getAttribute('id');

                    setView({...view, ["v"]:v, ["id"]:id });
            }


            const recalculateAmong = () => {

                        var tabRef = JSON.parse(  JSON.stringify(row) ); //new ref

                        var tRef    = tabRef["pozycje"];

                        var sumNetto  = 0;
                        var sumVAT    = 0;
                        var sumBrutto = 0;

                        for(var x=0; x < tRef.length; x++)
                        {
                            var cena_netto =  parseFloat( tRef[x]["cena_j_netto"] ) * parseFloat( tRef[x]["ilosc"] );

                             tRef[x]["cena_netto"]  =  parseFloat( cena_netto ).toFixed(2);

                             var proc = parseFloat( parseFloat( tRef[x]["stawka_vat"])  / 100.0).toFixed(2); 

                             var razem_vat =  parseFloat( tRef[x]["cena_netto"] * proc ).toFixed(2);
                             tRef[x]["razem_vat"]  = razem_vat;

                             //tRef[x]["cena_brutto"]  = parseFloat(   tRef[x]["cena_netto"]   +   tRef[x]["razem_vat"]  ).toFixed(2) ;
                             tRef[x]["cena_brutto"]  = parseFloat(  parseFloat( tRef[x]["cena_netto"] ) + parseFloat(     tRef[x]["razem_vat"]  )  ).toFixed(2) ;


                             sumNetto    = parseFloat( parseFloat( sumNetto) + parseFloat( tRef[x]["cena_netto"] )  ).toFixed(2);
                             sumVAT      = parseFloat( parseFloat( sumVAT) +  parseFloat( tRef[x]["razem_vat"]  )  ).toFixed(2);
                             sumBrutto   = parseFloat( parseFloat( sumBrutto) +  parseFloat( tRef[x]["cena_brutto"]  )  ).toFixed(2);

                        }

                        tabRef['razem_netto'] = sumNetto;
                        tabRef['razem_vat'] = sumVAT;
                        tabRef['razem_brutto'] = sumBrutto;
                        tabRef['do_zaplaty'] = sumBrutto;


                        if( row["org_faktura"] != undefined) //to jest korekta jakies faktury...
                        {
                            var orgDoZaplaty = row.org_faktura.do_zaplaty;
                            var roznica =  parseFloat(  tabRef['do_zaplaty'] ) - parseFloat( row.org_faktura.do_zaplaty );
                            roznica = parseFloat(roznica).toFixed(2);

                           // console.log("roznica", roznica);
                            tabRef['roznica'] = roznica;
                        }


                        setRow(tabRef);
                        setGoCalculate(0); //przeliczono


            }

            const valChangeListener = (filedName, val, correct, msg) => {                         
        
                if(row.anulowana == 1) return;
                if(row.zatwierdzona != 0 && row.zatwierdzona  != -10 ) return;


                setIsChanged(1);

                //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
                var tabCheck = filedName.split('@');
                if(tabCheck.length == 3) //pozycje..
                {

                    console.log(tabCheck);
                

                    var tabName    = tabCheck[0];
                    var tabInx     = tabCheck[1];
                    var filedName  = tabCheck[2];

                    var tRef    = row[tabName];
                    tRef[tabInx][filedName] = val;
                    tmpRow[tabName] = tRef;     

 

                    setRow(  JSON.parse(JSON.stringify(tmpRow)) );  
                    setGoCalculate(1); //niech przeliczy jeszcze raz               
        
                    //setRowX( {...row, [tabName]:tRef } );   
                   // if(Config.env == "dev") console.log("ClientForm valChangeListner", tmpRow);
                    return;
                }
        
            
                tmpRow[filedName] = val;
                tmpRow[filedName+"_valid"] = correct;             
                setRow(  JSON.parse(JSON.stringify(tmpRow)) );                             
                //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );                        
            }   
        
        
            const goNextNew = () => {
                        console.log("goNext");               
                    }



            const valChecker = (fields) => {

                    var allValid = true;

                        
                    console.log(JSON.stringify(fields) );

                    Object.entries(fields).forEach(function(entry) {

                        var xKey    = entry[0];
                        var xValue  = entry[1];                    

                        var xValidName = xKey + "_valid";

                        if(fields[xValidName] == false)
                        {
                            allValid = false;
                            if(Config.env == 'dev') console.log("Error field: " + xKey);
                        }
                        
                    });
                    
                    return allValid;

                }

                

            const getCalcDet = () => {    

                 
                    props.mainView.showProgress();

                    fetch( Config.url + '/rest_v1_calc,invoice_det', {
                        method: 'POST', 
                        body: JSON.stringify( { id: props.id}), 
                        headers: {
                            'Content-Type': 'application/json',                    
                            'X-Api-Key': props.userData.apiKey,
                            '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                            '_sec_key_': Config.genXKey() ,
                        }
                    })
                    .then(res => res.json() )
                    .then(res => { 

                                props.mainView.hideProgress();

                                if(res._sys_ == undefined)
                                {
                                    props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                }else
                                if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                {
                                    props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                }else    
                                {
                                    var resX = res.result;     
                                    
                                    resX["poz_max"] = res.result.pozycje.length;
                                    
                                    for(var x = 0; x < defPoz.length; x++)
                                    {                                        
                                         if( resX.pozycje[x] == undefined || resX.pozycje[x] == null )       
                                         {                                           
                                             resX.pozycje[x] =    defPoz[x] ;
                                         }
                                         
                                    }


                                    setRow(resX);  

                                    setTimeout(()=>{
                                            setIsChanged(0); 
                                    }, 200);                                                                                                              
                                }
                    } )
                    .catch(err => {          
                                props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                props.mainView.hideProgress();
                    });
                            

                    return false;
                } 


            const addItem = () => {
               
                setRow( {...row, ["poz_max"]: row.poz_max+1 } );
                setGoCalculate(1); //niech przeliczy jeszcze raz       

                setTimeout( ()=>{

                    //f_poz_name                  
                    var el = document.getElementsByClassName("f_poz_name");
                    //console.log(el[el.length-1]);
                    el[el.length-1].focus();
                   

                }, 200 );
            }    


            const removeItem = (e) => {
               
                    var inx = e.target.getAttribute('atr-inx');

                    var newArra = [];

                    for(var k=0; k< row.pozycje.length; k++)
                    {
                        if(k == inx) continue;

                        newArra.push( row.pozycje[k] );
                    }

                    
                    setRow({...row, ["pozycje"]: newArra , ["poz_max"]: (row.poz_max-1) } );                                       
                    setGoCalculate(1); //niech przeliczy jeszcze raz                 
            }



            const goUnlock = () => {    

                    props.mainView.showDialog( "Potwierdź", "Na pewno chcesz cofnąć wystawiony dokument? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {
                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,invoice_unlock', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: props.id}), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Dokument odblokowany. Pamiętaj by zatwierdzić go ponownie." , "ok" , null);  
                                                         getCalcDet();                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                            

                    return false;
                } 


            const goApprove = (e) => {    

                    if(row.poz_max < 1)
                    {
                        props.mainView.showDialog( "Ups!", "Nie można zatwierdzić - dokument nie zawiera żadnych pozycji" , "ok" , null);
                        return; 
                    }

                    if(isChanged == 1)
                    {
                         props.mainView.showDialog( "Potwierdź", "Przed wystawieniem dokumentu zapisz zmiany." , "ok" , null);
                        return;
                    
                    }
                   
                    var send = '0';

                    if(e != undefined && e.target != undefined)
                    {
                        send = e.target.getAttribute("atr-send");
                    }



                      var req = {
                        faktury: [{
                            id: props.id
                        }],
                    };

                 

                    props.mainView.showDialog( "Potwierdź", "Na pewno chcesz wystawić dokument? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {
                                        var msgX = "";
                                
                                        props.mainView.showProgress();

                                         fetch( Config.url + '/rest_v1_calc,invoice_approve', {
                                            method: 'POST', 
                                            body: JSON.stringify(  req ), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(  res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {                                                        
                                                         props.mainView.showDialog( "Sukces", "Faktura została dodana do kolejki wystawianych dokumentów"  , "ok" , (respx)=>{
                                                           getCalcDet();  
                                                         });  
                                                                                                                                                                                          
                                                    }
                                        } )
                                        .catch(err => {    
 

                                                    props.mainView.showDialog( "Ups!", "I: " + err + "  (   )  ", "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                            

                    return false;
                } 



            const goCancel = () => {    

                    props.mainView.showDialog( "Potwierdź", "Na pewno chcesz anulować wystawiony dokument? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {
                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,invoice_cancel', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: props.id}), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Dokument został anulowany." , "ok" , null);  
                                                         getCalcDet();                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                            

                    return false;
                }   
                
            const goSend = () => {    

                    props.mainView.showDialog( "Potwierdź", "Na pewno chcesz wysłać dokument? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,invoice_send', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: props.id}), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Dokument został wysłany" , "ok" , null);  
                                                         getCalcDet();                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                            

                    return false;
                }  
            
              
              const goPrint = () => {    

                    props.mainView.showDialog( "Potwierdź", "Na pewno chcesz wydrukować dokument? " , "yesno" ,  (res) => {

                            if(res == 'yes')
                            {                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,invoice_print', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: props.id}), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         props.mainView.showDialog( "Sukces", "Dokument został wysłany do drukarki" , "ok" , null);  
                                                         getCalcDet();                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });


                            }

                    } );   


                  
                            

                    return false;
                }     

            const goUpdate = () => {   
                              
              //   if(row.anulowana != 0 || row.zatwierdzona != 0 || row.zatwierdzona != -10  ) return;


                if(row.data_wystawienia.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj datę wystawienia dokumentu" , "error" , null);  
                     setChecked1(1); setChecked2(0); setChecked3(0); setChecked4(0);
                     return;
                }

                if(row.data_sprzedazy.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj datę sprzedaży" , "error" , null);  
                     setChecked1(1); setChecked2(0); setChecked3(0); setChecked4(0);
                     return;
                }

                if(row.termin_platnosci.length < 3 && row.platnosc_z_gory == '0')
                {
                     props.mainView.showDialog( "Ups!", "Podaj termin płatności" , "error" , null);  
                     setChecked1(1); setChecked2(0); setChecked3(0); setChecked4(0);
                     return;
                }

                 if(row.sp_nip.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj NIP sprzedawcy" , "error" , null);  
                     setChecked1(0); setChecked2(1); setChecked3(0); setChecked4(0);
                     return;
                }

                if(row.sp_nazwa.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj nazwę sprzedawcy" , "error" , null);  
                     setChecked1(0); setChecked2(1); setChecked3(0); setChecked4(0);
                     return;
                }

                if(row.sp_ulica.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe sprzedawcy (ulica)" , "error" , null);  
                     setChecked1(0); setChecked2(1); setChecked3(0); setChecked4(0);
                     return;
                }

                if(row.sp_kod_pocztowy.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe sprzedawcy (kod pocztowy)" , "error" , null);  
                     setChecked1(0); setChecked2(1); setChecked3(0); setChecked4(0);
                     return;
                }

                if(row.sp_miejscowosc.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe sprzedawcy (miejscowość)" , "error" , null);  
                     setChecked1(0); setChecked2(1); setChecked3(0); setChecked4(0);
                     return;
                }


                if(row.kl_nip.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj NIP nabywcy" , "error" , null);  
                     setChecked1(0); setChecked2(0); setChecked3(1); setChecked4(0);
                     return;
                }

                if(row.kl_nazwa.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj nazwę nabywcy" , "error" , null);  
                     setChecked1(0); setChecked2(0); setChecked3(1); setChecked4(0);
                     return;
                }

                if(row.kl_ulica.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe nabywcy (ulica)" , "error" , null);  
                     setChecked1(0); setChecked2(0); setChecked3(1); setChecked4(0);
                     return;
                }

                 if(row.kl_kod_pocztowy.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe nabywcy (kod pocztowy)" , "error" , null);  
                     setChecked1(0); setChecked2(0); setChecked3(1); setChecked4(0);
                     return;
                }

                if(row.kl_miejscowosc.length < 3)
                {
                     props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe nabywcy (miejscowość)" , "error" , null);  
                     setChecked1(0); setChecked2(0); setChecked3(1); setChecked4(0);
                     return;
                }

                if(row.odbr_nazwa.length > 1 || row.odbr_nip.length > 1)
                {
                            if(row.odbr_nip.length < 3)
                            {
                                props.mainView.showDialog( "Ups!", "Podaj NIP odbiorcy" , "error" , null);  
                                setChecked1(0); setChecked2(0); setChecked3(0); setChecked4(1);
                                return;
                            }

                            if(row.odbr_nazwa.length < 3)
                            {
                                props.mainView.showDialog( "Ups!", "Podaj nazwę odbiorcy" , "error" , null);  
                                setChecked1(0); setChecked2(0); setChecked3(0); setChecked4(1);
                                return;
                            }

                            if(row.odbr_ulica.length < 3)
                            {
                                props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe odbiorcy (ulica)" , "error" , null);  
                                setChecked1(0); setChecked2(0); setChecked3(0); setChecked4(1);
                                return;
                            }

                            if(row.odbr_kod_pocztowy.length < 3)
                            {
                                props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe odbiorcy (kod pocztowy)" , "error" , null);  
                                setChecked1(0); setChecked2(0); setChecked3(0); setChecked4(1);
                                return;
                            }

                            if(row.odbr_miejscowosc.length < 3)
                            {
                                props.mainView.showDialog( "Ups!", "Podaj poprawnę dane adresowe odbiorcy (miejscowość)" , "error" , null);  
                                setChecked1(0); setChecked2(0); setChecked3(0); setChecked4(1);
                                return;
                            }
                }

                                                
                                        props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,invoice_update', {
                                            method: 'POST', 
                                            body: JSON.stringify(row), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                     props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         
                                                         props.mainView.showDialog( "Sukces", "Dokument został zapisany" , "ok" ,  (resp)=>{                                                     
                                                            getCalcDet();
                                                         } );                                                                                                                            
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        });

        

                    return false;
                } 
                

            const goDuplicate = () => {
                setView({v:'duplicate', id: -1});
            }    

            const goDuplicateOK = () => {

                if(nParam == undefined ) return;
                if(nParam.length < 3) return;


                                     props.mainView.showProgress();

                                        fetch( Config.url + '/rest_v1_calc,invoice_duplicate', {
                                            method: 'POST', 
                                            body: JSON.stringify( { id: props.id, date: nParam }), 
                                            headers: {
                                                'Content-Type': 'application/json',                    
                                                'X-Api-Key': props.userData.apiKey,
                                                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                                                '_sec_key_': Config.genXKey() ,
                                            }
                                        })
                                        .then(res => res.json() )
                                        .then(res => { 

                                                    props.mainView.hideProgress();

                                                    if(res._sys_ == undefined)
                                                    {
                                                        props.mainView.showDialog( "Ups!", "No correct response from server" , "error" , null);  
                                                    }else
                                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                                    {
                                                        props.mainView.showDialog( "Ups!", JSON.stringify(res.result) , "error" , null);  
                                                    }else    
                                                    {
                                                         setView( {v:'list', id: -1} );
                                                         getCalcDet(); 
                                                         props.mainView.showDialog( "Sukces", "Duplikat został wystawiony." , "ok" , null);                                                                                                                                     
                                                    }
                                        } )
                                        .catch(err => {          
                                                    props.mainView.showDialog( "Ups!", "I: " + err , "error" , null);
                                                    props.mainView.hideProgress();
                                        }); 

            }



            const keyListener = (e) => {

                                var code = e.keyCode ? e.keyCode : e.which;    
                                console.log("keylockd", e.target.nodeName, code );
                               
                                if(e.target.nodeName.toLowerCase() != "body" && code == 27 )                                                  
                                {
                                    e.target.blur();
                                }else 
                                if(e.target.nodeName.toLowerCase() == "body" && code == 27 )                                                  
                                {                                                                
                                } else
                                if(e.target.nodeName.toLowerCase() == "body" && code == 107 )  // +
                                {
                                    addItem();
                                }else 
                                if(e.target.nodeName.toLowerCase() == "body" && code == 8 )                                                  
                                {
                                        props.onSuccess();                               
                                } else 
                                if( e.shiftKey   && code == 13 )   //enter // wystaw
                                {
                                        goApprove();
                                }else
                                if( e.ctrlKey && code == 83 )   //zapisz                                               
                                {
                                       if(row.anulowana != 0 && row.zatwierdzona != 0)
                                       {
                                            props.mainView.showDialog( "Ups!", "Nie można zapisać zmian (dokument wystawiony lub anulowany)" , "error" , null);  
                                       }else{
                                            goUpdate();    
                                       }

                                                            
                                       e.preventDefault();
                                } else 
                                {
                                    props.keyListener(e);
                                }
                    
            }


            useEffect(() => {
                         
                        if(row.id < 0 && props.id > 0 )
                        {
                            getCalcDet();
                        }

                        if(goCalculate == 1)
                        {
                           recalculateAmong();                           
                        }                        

                        if(Config.env == "dev") console.log("InvoiceForm.js, listener on");
                        window.onkeydown = keyListener;

                        return () => {          
                            if(Config.env == "dev") console.log("InvoiceForm.js, listener off");      
                            window.onkeydown = props.keyListener;
                        };
            });  
            

            if(row == null )
            {
                return <div>...</div>
            }


            document.title = row.numer_dokumentu;

            if(row.zatwierdzona == 0)
            {
                document.title = "Dokument niezatwierdzony";
            }

            var cssInvoice = "";
            var cssKsefInvoice = "";

            if(row.zatwierdzona == 1) cssInvoice = " approved ";
            if(row.zatwierdzona == 0) cssInvoice = " waiting ";
            if(row.anulowana == 1) cssInvoice = " canceled ";

            if(row.ksef_wyslano == 1) cssKsefInvoice = " approved ";
            if(row.ksef_wyslano == 0) cssKsefInvoice = " waiting ";

            var dialog = null;


            if(view.v == "duplicate")
            {
                  dialog =  <div className="dlg_window shadowx " >

                        <div className="dlg_title" >Nowy duplikat faktury</div>
                        <div className="dlg_msg" >

                            
                                    <InputDate  value={nParam} err={null}  valChange={paramListener} goNext={null}   name={"nParam"} placeholder={": "} className=' w300 ' req='0' firstUp="0" />
                                        
                                    </div>
                                            <div className="dlg_btn">
                                                <div className="btn" onClick={changeView} v="list" id="-1" >zamknij</div>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                <div className="btn" atr-type="ok" onClick={goDuplicateOK}>utwórz</div>
                                    </div>
                    </div>
            }


            if(view.v == "client")
            {                                 
                    return <ClientReview  userData={props.userData} mainView={props.mainView}  keyListener={keyListener}  onBack={onBack}  onSuccess={onSuccess}   id={row.klient.id} />
            }


            if(view.v == "calc")
            {
        
                return <CalculateReview  userData={props.userData} mainView={props.mainView} keyListener={keyListener} onBack={onBack}  onSuccess={onSuccess}  fak_kontrahenci_id={props.fak_kontrahenci_id}  id={row._saldo_.id}   />
            }




            return <div className="view_content">
                        <img src={back} onClick={props.onSuccess} className="back_img" title="wstecz"/>

                         <div className="location">Panel / Lista faktur / Szczegóły faktury</div>

                          <div className="app_header">                            
                            {
                                row.zatwierdzona == 0 &&
                                <div>
                                    Brak nadanego numeru, dokument nie został jeszcze wystawiony &nbsp;
                                    {
                                        (props.fak_kontrahenci_id == undefined || props.fak_kontrahenci_id == -1) && 
                                        <sup  className="link_normal"  v="client" id="-1" onClick={changeView}>idź do klienta</sup> 
                                    }
                                </div>
                            }

                            {
                                row.zatwierdzona == -10 &&
                                <div className="color_show4">
                                    Dokument wygenerowany w czasie, gdy klient miał wstrzymane fakturowanie&nbsp;
                                    {
                                        (props.fak_kontrahenci_id == undefined || props.fak_kontrahenci_id == -1) && 
                                        <sup  className="link_normal"  v="client" id="-1" onClick={changeView}>idź do klienta</sup> 
                                    }
                                </div>
                            }

                            {
                                row.zatwierdzona == 1 &&
                                <div> {row.nazwa}  nr  {row.numer_dokumentu} z dnia {row.data_wystawienia} &nbsp;
                                    {
                                        (props.fak_kontrahenci_id == undefined || props.fak_kontrahenci_id == -1) && 
                                        <sup  className="link_normal"  v="client" id="-1" onClick={changeView}>idź do klienta</sup> 
                                    }
                                    &nbsp;
                                    <sup  className="link_normal"  v="calc" id="-1" onClick={changeView}>idź do rozliczeń</sup> 
                                    
                                </div>
                            }

                             
                        </div>

                        <div className={"client_info " + cssKsefInvoice}>  
                            <b>Status KSEF: </b> {row.ksef_status},
                            &nbsp; 
                            &nbsp; 
                            <b>Numer KSEF:  </b> {row.ksef_numer}
                            &nbsp; 
                            &nbsp; 
                            <b>Data wysyłki do KSEF:  </b> {row.ksef_datagodz_wyslania}
                        </div>

                        <div className={"client_info " + cssInvoice}>                             

                            { 
                                  row.zatwierdzona == 1 && row.anulowana == 1 && 
                                  <Fragment>
                                        <b>Anulowany</b>                                                                          
                                  </Fragment>                                  
                             }
                             { 
                                  row.zatwierdzona == 1 && row.anulowana == 0 && 
                                  <Fragment>
                                        <b>Zatwierdzona</b>                                    
                                        <MenuNormal>
                                            <ul>

                                                {
                                                    row.ksef_wyslano == '0' &&
                                                    <Fragment>
                                                        <li onClick={goUnlock}>cofnij wyst.</li>                         
                                                        <li onClick={goCancel}>anuluj dokument</li> 
                                                    </Fragment>
                                                }                                                                        

                                                <li onClick={goSend}>wyślij dokument</li>                         
                                                <li onClick={goPrint}>drukuj</li>                         
                                                <li  atr-id={row.id} atr-title={row.numer_dokumentu} onClick={props.goDownload}>pobierz pdf</li>                         
                                                {
                                                    row.ksef_numer.length < 10 && 
                                                    <li  onClick={goDuplicate} >wystaw duplikat</li>           
                                                }
                                                             
                                            </ul>
                                        </MenuNormal> 
                                  </Fragment>                                  
                             }

                              { 
                                  (row.zatwierdzona == 0 || row.zatwierdzona == -10 ) &&  row.anulowana == 0  && row.poz_max > 0 && isChanged == 0 &&
                                  <Fragment>
                                        <b>Oczekuje na wystawienie</b>                                     
                                        <MenuNormal>
                                            <ul>
                                                <li atr-send="0" onClick={goApprove}>wystaw</li>
                                                <li  atr-send="1" onClick={goApprove} style={{display:'none'}}>wystaw i wyślij</li>
                                                <li  atr-id={row.id} atr-title={row.numer_dokumentu} onClick={props.goDownload}>podgląd pdf</li>    
                                            </ul>
                                        </MenuNormal> 
                                  </Fragment>                                  
                             }                          

                             &nbsp; Razem netto: <b><FormatDecimal value={row.razem_netto} /> </b>
                             &nbsp; Razem vat: <b><FormatDecimal value={row.razem_vat} /> </b>
                             &nbsp; Razem brutto: <b><FormatDecimal value={row.razem_brutto} /> </b>
                             &nbsp; Do zapłaty: <b><FormatDecimal value={row.do_zaplaty} /> </b>
                        </div>


                        {
                            row.email_info != undefined && row.email_info.length > 0 &&
                            <div className={"client_info " }>                               
                                <b>Email labs:</b> {row.email_info}
                            </div>
                        }                        

                        <div className={"client_info " }>   

                          
                            <label className="switch" title="Więcej">                               
                                <input type="checkbox" checked={checked1}  onChange={handleChange1}/>
                                <span className="slider round"></span>
                            </label>&nbsp; &nbsp; 

                            Data wystawienia: <b>{row.data_wystawienia}</b>
                            &nbsp;
                            Data sprzedaży: <b>{row.data_sprzedazy}</b>
                            {
                                 row.platnosc_z_gory == '0' && 
                                 <Fragment>
                                        &nbsp;
                                        Płatne do: <b>{row.termin_platnosci}</b>
                                 </Fragment>
                            }

                              {
                                 row.platnosc_z_gory == '1' && 
                                 <Fragment>
                                        &nbsp;
                                        Płatność z góry
                                 </Fragment>
                            }

                            &nbsp; Odwrotne obciążenie: &nbsp; 
                            {
                                row.odwrotne_obciazenie == '1' && <b>Tak</b>
                            }
                             {
                                row.odwrotne_obciazenie == '0' && <b>Nie</b>
                            }

                             &nbsp;,    
                            {
                                row.sposob_platnosci == 'przelew_bankowy' && <span> Przelew bankowy</span>
                            }

                            {
                                row.sposob_platnosci == 'gotowka' && <span> Gotówka</span>
                            }

                            {
                                row.sposob_platnosci == 'Płatności elektroniczne' && <span> Płatności elektroniczne</span>
                            }

                             {
                                row.sposob_platnosci == 'Kompensata' && <span> Kompensata</span>
                            }
                            
                            {
                                checked1 &&
                                <Fragment>
                                     <br/>&nbsp;<br/>
                                     <div className="eForm eForm100 bg_center">
                                            <div className="form_control">
                                                <div className="fieldName">Data wystawienia*</div>
                                                <InputDate  value={row.data_wystawienia} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"data_wystawienia"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>
                                            <div className="form_control">
                                                <div className="fieldName">Data sprzedaży*</div>
                                                <InputDate  value={row.data_sprzedazy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"data_sprzedazy"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>


                                              <div className="form_control">
                                                <div className="fieldName">Odwrotne obciążenie*</div>
                                                <InputCombo items={ [ {v:'0',title:'Nie'},  {v:'1',title:'Tak'},   ] }  value={row.odwrotne_obciazenie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odwrotne_obciazenie"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">Płatność z góry*</div>
                                                <InputCombo items={ [ {v:'0',title:'Nie'},  {v:'1',title:'Tak'},   ] }  value={row.platnosc_z_gory} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"platnosc_z_gory"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>
                                            
                                            {
                                                row.platnosc_z_gory == '0' &&
                                                 <div className="form_control">
                                                    <div className="fieldName">Termin płatności*</div>
                                                    <InputDate  value={row.termin_platnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"termin_platnosci"} placeholder={": "} className='  ' req='0' firstUp="0" />
                                                </div>
                                            }
                                           

                                            {
                                                row.platnosc_z_gory != '0' &&
                                                <div className="form_control">
                                                    <div className="fieldName">Sposób płatności*</div>
                                                    <InputCombo  items={ [ {v:'przelew_bankowy',title:'Przelew bankowy'}, {v:'gotowka',title:'Gotówka'}, {v:'Płatności elektroniczne',title:'Płatności elektroniczne'},  {v:'Kompensata',title:'Kompensata'},   ] } value={row.sposob_platnosci} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sposob_platnosci"} placeholder={": "} className='  ' req='0' firstUp="0" />
                                               </div>

                                            }                                            

                                    </div>
                                </Fragment>
                               
                            }
                        </div>

                        <div className={"client_info " }>   
                            <label className="switch" title="Więcej">                               
                                <input type="checkbox" checked={checked2}  onChange={handleChange2}/>
                                <span className="slider round"></span>
                            </label>&nbsp; &nbsp; 

                            <b>Sprzedawca: </b>  {row.sp_nip} {row.sp_nazwa} {row.sp_ulica}   {row.sp_kod_pocztowy} {row.sp_miejscowosc}
                               {
                                checked2 &&
                                <Fragment>
                                     <br/>&nbsp;<br/>
                                     <div className="eForm eForm100 bg_center">

                                            <div className="form_control">
                                                <div className="fieldName">NIP*</div>
                                                <InputNIP  value={row.sp_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sp_nip"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>   

                                            <div className="form_control">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText  value={row.sp_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sp_nazwa"} placeholder={": "} className=' w300 ' req='1' firstUp="0" />
                                            </div>    

                                            <div className="form_control">
                                                <div className="fieldName">Ulica*</div>
                                                <InputText  value={row.sp_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sp_ulica"} placeholder={": "} className=' w300 ' req='1' firstUp="0" />
                                            </div>     

                                              <div className="form_control">
                                                <div className="fieldName">Kod pocztowy*</div>
                                                <InputPostCode  value={row.sp_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sp_kod_pocztowy"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>  

                                             <div className="form_control">
                                                <div className="fieldName">Miejscowość*</div>
                                                <InputText  value={row.sp_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"sp_miejscowosc"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>                                      
                                    </div>
                                </Fragment>
                               
                            }
                        </div>

                        <div className={"client_info " }>   
                            <label className="switch" title="Więcej">                               
                                <input type="checkbox" checked={checked3}  onChange={handleChange3}/>
                                <span className="slider round"></span>
                            </label>&nbsp; &nbsp;           
                            <b>Nabywca:</b> {row.kl_kod_kraju}  {row.kl_nip}  {row.kl_nazwa} {row.kl_ulica} {row.kl_kod_pocztowy} {row.kl_miejscowosc}
                             {
                                checked3 &&
                                <Fragment>
                                     <br/>&nbsp;<br/>
                                     <div className="eForm eForm100 bg_center">


                                             <div className="form_control">
                                                <div className="fieldName">Kod Kraju </div>
                                                <InputCombo items={ [ {v:'AT',title:'AUSTRIA'},{v:'BE',title:'BELGIA'},{v:'BG',title:'BUŁGARIA'},{v:'CY',title:'CYPR'},{v:'CZ',title:'CZECHY'},{v:'DK',title:'DANIA'},{v:'EE',title:'ESTONIA'},{v:'FI',title:'FINLANDIA'},{v:'FR',title:'FRANCJA'},{v:'DE',title:'NIEMCY'},{v:'EL',title:'GRECJA'},{v:'HR',title:'CHORWACJA'},{v:'HU',title:'WĘGRY'},{v:'IE',title:'IRLANDIA'},{v:'IT',title:'WŁOCHY'},{v:'LV',title:'ŁOTWA'},{v:'LT',title:'LITWA'},{v:'LU',title:'LUKSEMBURG'},{v:'MT',title:'MALTA'},{v:'NL',title:'HOLANDIA'},{v:'PL',title:'POLSKA'},{v:'PT',title:'PORTUGALIA'},{v:'RO',title:'RUMUNIA'},{v:'SK',title:'SŁOWACJA'},{v:'SI',title:'SŁOWENIA'},{v:'ES',title:'HISZPANIA'},{v:'SE',title:'SZWECJA'},{v:'XI',title:'IRLANDIA PÓŁNOCNA'} ] }   userData={props.userData} value={row.kl_kod_kraju} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="kl_kod_kraju" placeholder={"Kod kraju:"} className=' w200 ' req='1' firstUp="1" />
                                            </div>

                                            <div className="form_control">
                                                <div className="fieldName">NIP*</div>
                                                <InputNIP  value={row.kl_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kl_nip"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>   

                                            <div className="form_control">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText  value={row.kl_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kl_nazwa"} placeholder={": "} className=' w300 ' req='1' firstUp="0" />
                                            </div>    

                                            <div className="form_control">
                                                <div className="fieldName">Ulica*</div>
                                                <InputText  value={row.kl_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kl_ulica"} placeholder={": "} className=' w300 ' req='1' firstUp="0" />
                                            </div>     

                                              <div className="form_control">
                                                <div className="fieldName">Kod pocztowy*</div>
                                                <InputPostCode  value={row.kl_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kl_kod_pocztowy"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>  

                                             <div className="form_control">
                                                <div className="fieldName">Miejscowość*</div>
                                                <InputText  value={row.kl_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"kl_miejscowosc"} placeholder={": "} className='  ' req='1' firstUp="0" />
                                            </div>                                      
                                    </div>
                                </Fragment>
                               
                            }
                        </div>
                        
                        <div className={"client_info " }>   
                            <label className="switch" title="Więcej">                               
                                <input type="checkbox" checked={checked4}  onChange={handleChange4}/>
                                <span className="slider round"></span>
                            </label>&nbsp; &nbsp;           
                            <b>Odbiorca:</b> {row.odbr_kod_kraju} {row.odbr_nip}   {row.odbr_nazwa} {row.odbr_ulica} {row.odbr_kod_pocztowy} {row.odbr_miejscowosc}
                             {
                                checked4 &&
                                <Fragment>
                                     <br/>&nbsp;<br/>
                                     <div className="eForm eForm100 bg_center">

                                            <div className="form_control">
                                                <div className="fieldName">Kod Kraju </div>
                                                <InputCombo items={ [ {v:'AT',title:'AUSTRIA'},{v:'BE',title:'BELGIA'},{v:'BG',title:'BUŁGARIA'},{v:'CY',title:'CYPR'},{v:'CZ',title:'CZECHY'},{v:'DK',title:'DANIA'},{v:'EE',title:'ESTONIA'},{v:'FI',title:'FINLANDIA'},{v:'FR',title:'FRANCJA'},{v:'DE',title:'NIEMCY'},{v:'EL',title:'GRECJA'},{v:'HR',title:'CHORWACJA'},{v:'HU',title:'WĘGRY'},{v:'IE',title:'IRLANDIA'},{v:'IT',title:'WŁOCHY'},{v:'LV',title:'ŁOTWA'},{v:'LT',title:'LITWA'},{v:'LU',title:'LUKSEMBURG'},{v:'MT',title:'MALTA'},{v:'NL',title:'HOLANDIA'},{v:'PL',title:'POLSKA'},{v:'PT',title:'PORTUGALIA'},{v:'RO',title:'RUMUNIA'},{v:'SK',title:'SŁOWACJA'},{v:'SI',title:'SŁOWENIA'},{v:'ES',title:'HISZPANIA'},{v:'SE',title:'SZWECJA'},{v:'XI',title:'IRLANDIA PÓŁNOCNA'} ] }   userData={props.userData} value={row.odbr_kod_kraju} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="odbr_kod_kraju" placeholder={"Kod kraju:"} className=' w200 ' req='1' firstUp="1" />
                                            </div>


                                            <div className="form_control">
                                                <div className="fieldName">NIP*</div>
                                                <InputNIP  value={row.odbr_nip} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odbr_nip"} placeholder={": "} className='  ' req='0' firstUp="0" />
                                            </div>   

                                            <div className="form_control">
                                                <div className="fieldName">Nazwa*</div>
                                                <InputText  value={row.odbr_nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odbr_nazwa"} placeholder={": "} className=' w300 ' req='0' firstUp="0" />
                                            </div>    

                                            <div className="form_control">
                                                <div className="fieldName">Ulica*</div>
                                                <InputText  value={row.odbr_ulica} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odbr_ulica"} placeholder={": "} className=' w300 ' req='0' firstUp="0" />
                                            </div>     

                                              <div className="form_control">
                                                <div className="fieldName">Kod pocztowy*</div>
                                                <InputPostCode  value={row.odbr_kod_pocztowy} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odbr_kod_pocztowy"} placeholder={": "} className='  ' req='0' firstUp="0" />
                                            </div>  

                                             <div className="form_control">
                                                <div className="fieldName">Miejscowość*</div>
                                                <InputText  value={row.odbr_miejscowosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"odbr_miejscowosc"} placeholder={": "} className='  ' req='0' firstUp="0" />
                                            </div>                                      
                                    </div>
                                </Fragment>
                               
                            }
                        </div>




                          <div className={"client_info " }>   
                            <label className="switch" title="Więcej">                               
                                <input type="checkbox" checked={checked5}  onChange={handleChange5}/>
                                <span className="slider round"></span>
                            </label>&nbsp; &nbsp;           
                            <b>KSeF (dodatkowe informacje):</b> {row.dodatkowy_opis_1_klucz} -> {row.dodatkowy_opis_1_wartosc}
                             {
                                checked5 &&
                                <Fragment>
                                     <br/>&nbsp;<br/>
                                     <div className="eForm eForm100 bg_center">

                                            <div className="form_control">
                                                <div className="fieldName">Nazwa pola nr 1 (np. Numer klienta, Numer paragonu...)</div>
                                                <InputText  value={row.dodatkowy_opis_1_klucz} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"dodatkowy_opis_1_klucz"} placeholder={": "} className='  ' req='0' firstUp="0" />
                                            </div>   

                                            <div className="form_control">
                                                <div className="fieldName">Wartość pola nr 1 (np. 232/2/3/45)</div>
                                                <InputText  value={row.dodatkowy_opis_1_wartosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"dodatkowy_opis_1_wartosc"} placeholder={": "} className='  ' req='0' firstUp="0" />
                                            </div>  


                                             <div className="form_control">
                                                <div className="fieldName">Typ korekty</div>
                                                <InputCombo items={[ {v:'0',title:' --- ',}, {v:'10',title:'Korekta daty wystawienia',} ]}  value={row.korekta_typ} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"korekta_typ"} placeholder={": "} className='  ' req='0' firstUp="0" />
                                            </div>  
                                       
                                    </div>
                                </Fragment>
                               
                            }
                        </div>




                    <form className="eForm eForm100 bg_center">
                        <div className="form_tab">
                         {
                            row.org_faktura != undefined &&
                            <div className="bg_center">
   
                               
                                    <div className="form_tab_title">Pozycje na dokumencie pierwotnym {row.org_faktura.numer_dokumentu} ({row.poz_max}):</div>

                                        <table className="table">

                                                <thead>
                                                    <tr className="header">                                                                                               
                                                        <td className="td_left">LP</td>
                                                        <td>Nazwa</td>                                                                                                                                    
                                                        <td>Cena j. netto</td>                                                                                                                                    
                                                        <td>Ilość</td>                                                                                                                                    
                                                        <td>Stawka VAT</td>                                                                                                                                    
                                                        <td>Netto</td>                                                                                                                                    
                                                        <td>Vat</td>                                                                                                                                    
                                                        <td className="td_right">Brutto</td>                                                                                                                                           
                                                    </tr>
                                                </thead>
                                                {
                                                    row.org_faktura.pozycje.map( (poz,inx) => {

                                                           var rowStyle = " row ";
                                                            if(inx % 2 == 0 )rowStyle = " row2 ";

                                                        return <tr className={rowStyle}>
                                                                <td>{inx+1}</td>
                                                                <td>{poz.nazwa}</td>
                                                                <td className="goright"><FormatDecimal value={poz.cena_j_netto} /></td>
                                                                <td className="goright"><FormatDecimal value={poz.ilosc} /></td>
                                                                <td className="goright"><FormatDecimal value={poz.stawka_vat} /></td>
                                                                <td className="goright"><FormatDecimal value={poz.cena_netto} /></td>
                                                                <td className="goright"><FormatDecimal value={poz.razem_vat} /></td>
                                                                <td className="goright"><FormatDecimal value={poz.cena_brutto} /></td>
                                                        </tr>
                                                    } )
                                                }

                                                        <tr className="">
                                                                <td></td>
                                                                <td> </td>
                                                                <td className="goright"> </td>
                                                                <td className="goright"> </td>
                                                                <td className="goright"> </td>
                                                                <td className="goright gobold "><FormatDecimal value={row.org_faktura.razem_netto} /></td>
                                                                <td className="goright gobold "><FormatDecimal value={row.org_faktura.razem_vat} /></td>
                                                                <td className="goright gobold"><FormatDecimal value={row.org_faktura.razem_brutto} /></td>
                                                        </tr>

                                        </table>

                            

                            </div>
                         }       
                        </div>

                    </form>

                      
                        <form className="eForm eForm100 bg_center">

                                <div className="form_tab_title">Pozycje na dokumencie ({row.poz_max}):</div>
                                 <div className="form_tab">


                                        {
                                            row.anulowana == 0 && (row.zatwierdzona == 0 || row.zatwierdzona == -10) &&
                                            <Fragment>
                                                    <table>

                                                                                                {
                                                                                                    row.pozycje.map(  (poz, inx) => {

                                                                                                            if(inx >= row.poz_max) return null;

                                                                                                            return <tr className="fromRightToLeft">

                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">Nazwa*</div>
                                                                                                                            <InputText   userData={props.userData} value={poz.nazwa} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"pozycje@"+inx+"@nazwa"} placeholder={"Nazwa: "} className=' w250 f_poz_name ' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>

                                                                                                                
                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">Cena j. netto*</div>
                                                                                                                            <InputDecimal   userData={props.userData} value={poz.cena_j_netto} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"pozycje@"+inx+"@cena_j_netto"} placeholder={"Cena j. netto: "} className=' w100 ' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>

                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">Ilość*</div>
                                                                                                                            <InputDecimal   userData={props.userData} value={poz.ilosc} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"pozycje@"+inx+"@ilosc"} placeholder={"Ilość: "} className=' w50 ' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>

                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">JM*</div>
                                                                                                                            <InputCombo  items={[ {v:'szt.',title:'Szt.' }, {v:'godz.',title:'Godz.' }, {v:'mc',title:'Miesiąc' },    ]} userData={props.userData} value={poz.jm} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"pozycje@"+inx+"@jm"} placeholder={""} className=' w50 ' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>

                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">Stawka VAT*</div>
                                                                                                                            <InputDecimal   userData={props.userData} value={poz.stawka_vat} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"pozycje@"+inx+"@stawka_vat"} placeholder={"Stawka VAT: "} className=' w50 ' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>

                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">Netto*</div>
                                                                                                                            <InputDecimal   userData={props.userData} value={poz.cena_netto} err={errTab}  valChange={null} goNext={null} name={"pozycje@"+inx+"@cena_netto"} placeholder={"Razem netto: "} className=' w100 input_disable ' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>

                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">VAT*</div>
                                                                                                                            <InputDecimal   userData={props.userData} value={poz.razem_vat} err={errTab}  valChange={null} goNext={null} name={"pozycje@"+inx+"@razem_vat"} placeholder={"Razem vat: "} className=' w100 input_disable' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>

                                                                                                                <td>
                                                                                                                    <div className="form_control">
                                                                                                                            <div className="fieldName">Brutto*</div>
                                                                                                                            <InputDecimal   userData={props.userData} value={poz.cena_brutto} err={errTab}  valChange={null} goNext={null} name={"pozycje@"+inx+"@cena_brutto"} placeholder={"Razem brutto: "} className=' w100 input_disable' req='0' firstUp="0" />
                                                                                                                        </div>
                                                                                                                </td>

                                                                                                                <td>
                                                                                                                    &nbsp; 
                                                                                                                    {
                                                                                                                        row.zatwierdzona != 1 &&
                                                                                                                        <span className="btn" atr-inx={inx} onClick={removeItem}> usuń </span>
                                                                                                                    }                                                                
                                                                                                                </td>

                                                                                                            </tr>


                                                                                                    } )

                                                                                                }

                                                    </table>
                                                                                        {
                                                                                            row.zatwierdzona != 1 && 
                                                                                            <div onClick={addItem} className="btn">dodaj pozycje[+]</div>
                                                                                        }   
 

                                            </Fragment> 
                                        }



                                        {
                                            (!( row.anulowana == 0 && (row.zatwierdzona == 0 || row.zatwierdzona == -10) )) &&
                                            <Fragment>
                                                       <table className="table"  >

                                                            <tr className="header">                                                                                               
                                                                <td className="td_left">LP</td>
                                                                <td>Nazwa</td>                                                              
                                                                <td>Cena j. netto</td>                                                                        
                                                                <td>Ilość</td>                                                                        
                                                                <td>JM</td>                                                                        
                                                                <td>Stawka VAT</td>                                                                        
                                                                <td>Netto</td>                                                                        
                                                                <td>VAT</td>                                                                        
                                                                <td className="td_right" >Brutto</td>                                                                                                                                                                                                         
                                                            </tr>

                                                            {
                                                                   row.pozycje.map(  (poz, inx) => {

                                                                            if(inx >= row.poz_max) return null;

                                                                            var rowStyle = " row ";
                                                                            if(inx % 2 == 0 )rowStyle = " row2 ";


                                                                            return <tr className={rowStyle}>                                                                                                                                                                           
                                                                                <td className="gocenter">{inx+1}</td>
                                                                                <td>{poz.nazwa}</td>                                                              
                                                                                <td className="goright"><FormatDecimal value={poz.cena_j_netto} /></td>                                                                        
                                                                                <td className="gocenter"><FormatDecimal value={poz.ilosc} />  </td>                                                                        
                                                                                <td className="gocenter">{poz.jm}</td>                                                                        
                                                                                <td className="gocenter">{poz.stawka_vat}</td>                                                                        
                                                                                <td className="goright"><FormatDecimal value={poz.cena_netto} /> </td>                                                                        
                                                                                <td className="goright"><FormatDecimal value={poz.razem_vat} /> </td>                                                                        
                                                                                <td className="goright"><FormatDecimal value={poz.cena_brutto} /> </td>                                                                                                                                                                                                                                    
                                                                            </tr>


                                                                   }) 
                                                            }

                                                              <tr className="">                                                                                               
                                                                <td className=""> </td>
                                                                <td> </td>                                                              
                                                                <td> </td>                                                                        
                                                                <td> </td>                                                                        
                                                                <td> </td>                                                                        
                                                                <td> </td>                                                                        
                                                                <td className="goright"><FormatDecimal value={row.razem_netto} /></td>                                                                        
                                                                <td className="goright"><FormatDecimal value={row.razem_vat} /></td>                                                                        
                                                                <td className="goright" ><FormatDecimal value={row.razem_brutto} /></td>                                                                                                                                                                                                         
                                                            </tr>

                                                       </table>
                                            </Fragment>
                                        }
                                    
                                                                             
                                     

                                 </div>


                                {
                                      row.org_faktura != undefined && row.zatwierdzona != 1 && 
                                      <Fragment>
                                           <div className="form_split"></div>
                                           
                                            <div className="eForm eForm100 bg_center">

                                                    <div className="form_control">
                                                        <div className="fieldName">Powód korekty*</div>
                                                        <InputTextArea  value={row.uwagi} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"uwagi"} placeholder={"Powód korekty: "} className=' w400 h50  ' req='0' firstUp="0" />
                                                    </div>  
                                            </div>



                                      </Fragment>
                                }

                                  {
                                      row.org_faktura == undefined && row.zatwierdzona != 1 && 
                                      <Fragment>
                                           <div className="form_split"></div>
                                           
                                            <div className="eForm eForm100 bg_center">

                                                    <div className="form_control">
                                                        <div className="fieldName">Uwagi (info na fakturze)*</div>
                                                        <InputTextArea  value={row.uwagi} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name={"uwagi"} placeholder={"Uwagi: "} className=' w400 h50  ' req='0' firstUp="0" />
                                                    </div>  
                                            </div>



                                      </Fragment>
                                }

                                 
                                <div className="form_split"></div>

                                <div className="app_header">                            
                                    Do zapłaty: <FormatDecimal value={row.do_zaplaty} />

                                    {
                                        row.roznica != undefined && row.roznica > 0 &&
                                        <div>
                                            Dopłata względem dokumentu pierwotnego {row.org_faktura.numer_dokumentu}  wynosi: <FormatDecimal value={row.roznica}  />
                                        </div>
                                    }
                                    {
                                        row.roznica != undefined && row.roznica <= 0 &&
                                        <div>
                                            Niedopłata względem dokumentu pierwotnego  {row.org_faktura.numer_dokumentu}, wynosi: <FormatDecimal value={row.roznica}  />
                                        </div>
                                    }
                                </div>

                                <div className="form_split"></div>

                                <div className="form_btn">

                                        {                                                                         
                                              (row.zatwierdzona == 0 || row.zatwierdzona == -10 ) &&  row.anulowana == 0  && row.poz_max > 0 && isChanged == 0 &&
                                              <Fragment>
                                                   <div className="btn" onClick={goApprove} atr-send="0" >wystaw [shift +e enter]</div>
                                                   &nbsp; &nbsp;
                                              </Fragment>
                                        }

                                        {
                                            row.anulowana == 0 && (row.zatwierdzona == 0 || row.zatwierdzona == -10) &&
                                            <div className="btn" onClick={goUpdate}>zapisz zmiany [cntr+s]</div>
                                        }
                                        
                                        &nbsp;&nbsp;
                                        <div className="btn" onClick={props.onSuccess}    > wyjdź [back]</div>
                                </div>

                        </form>


                         {
                            row.duplikaty != undefined &&
                            <Fragment>
                                      <div className="bg_center">
                                         <h3 className="dash_header">Duplikaty faktury {row.numer_dokumentu} ({row.duplikaty.length})</h3>

                                          <table className="table"  >
                                            
                                                    <thead>
                                                        <tr className="header">                                                                                               
                                                            <td className="td_left">LP</td>
                                                            <td>Numer</td>                                                                                                                                                                                                                                                                                                                                                                              
                                                            <td className="td_right">Data wystawienia</td>                                                                                                                                      
                                                            <td className="td_option"></td>                                                                                  
                                                        </tr>
                                                    </thead>

                                                    <tbody>

                                                        {
                                                            row.duplikaty.map( (item, ix) => {

                                                                    var rowStyle = " row ";
                                                                    if(ix % 2 == 0 )rowStyle = " row2 ";

                                                                    return <tr className={rowStyle} key={ix}>
                                                                                <td className="gocenter">{ix+1}</td>    
                                                                                <td className="gocenter">{item.numer_dokumentu}</td>    
                                                                                <td className="gocenter">{item.data_wystawienia}</td>    
                                                                                <MenuTable>
                                                                                <ul>                                                                                    
                                                                                    <li   onClick={ props.goDownload } atr-id ={ item.id } atr-title ={ item.numer_dokumentu }  > Pobierz </li>                                                                                
                                                                                </ul>
                                                                            </MenuTable>
                                                                        </tr>

                                                            } )
                                                        }

                                                    </tbody>

                                          </table>
                                      </div>
                            </Fragment>
                         }

                        {dialog}                
                    </div>
}


export default InvoiceForm;